export const enum RestCounterType {
  RCR = 'rcr',
  RTT = 'rtt',
  HOLIDAYS = 'holidays'
}

export const enum CompensatoryRestCounterType {
  COMPENSATORY_REST = 'compensatory_rest',
  RTT_REST = 'rtt',
  PUBLIC_HOLIDAY_REST = 'public_holiday_compensatory'
}
